import React from 'react';
import {TypicalMessage, TypicalMessageProps} from './TypicalMessage';

export function OrderProductApprovalDeclined(props: TypicalMessageProps) {
    return <TypicalMessage
            model={props.model}
            options={props.options}
            replace={{status_was: '—', status_became: '—'}}
            messageKeysWithStatusId={['status_was', 'status_became']}
    />;
}
